<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/sellerDashboard/">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Returns</li>
    </ol>
  </nav>

  <div class="invalid-feedback d-block shift-invalid-text w-75" [hidden]="!errorMessage">{{errorMessage}}</div>
  <div class="row align-items-center">
    <div class="col-8">
      <ul class="list-inline tab-list deskContent">
        <ng-container *ngFor="let om of returnsMainMenu">
          <li *ngIf="om.additional === 'N'" class="list-inline-item">
            <a (click)="populateTabData(om.tabClicked,om.orderStatus); tabChange();"
               [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a></li>
        </ng-container>
        <li class="list-inline-item">
          <a data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">+ more</a>
          <div class="dropdown-menu dropdown-menu2">
            <ng-container *ngFor="let om of returnsMainMenu">
              <a *ngIf="om.additional === 'Y'" class="dropdown-item"
                 (click)="populateTabData(om.tabClicked,om.orderStatus);switchPosition(om)"
                 [ngClass]="{'active': tabClicked === om.tabClicked}">{{om.displayName}}</a>
            </ng-container>
          </div>
        </li>
      </ul>
      <select class="form-control MobileContent" id="use2r" [(ngModel)]="userDrop2"
              [ngModelOptions]="{standalone: true}" (change)="populate(userDrop2)" style="width: 140px;" required>
        <option *ngFor="let u of returnsMainMenu" [ngValue]="u.orderStatus" selected>{{u.displayName}}</option>
      </select>
    </div>
    <div class="col text-right">
      <div class="d-inline" *ngIf="tabClicked !== 'received' && tabClicked !== 'completed' && tabClicked !== 'all'">
        <button data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                class="btn ml-2 btn-outline-primary dropdown-toggle d-none-mobile btn-sm" *ngIf="(checkedList?.length)">
          Actions
        </button>
        <div class="dropdown-menu dropdown-menu2  dropdown-menu-right" *ngIf="(checkedList?.length)">

          <a *ngIf="tabClicked === 'submitted'" class="dropdown-item file btn shift-import">Cancel the Return
            Request</a>
          <a *ngIf="tabClicked === 'inTransit'" class="dropdown-item file btn shift-import">Cancel the Return
            Request</a>
        </div>
      </div>
    </div>


  </div>
  <div class="row">
    <div class="col">
      <div class="inner-box d-none d-sm-block" [ngClass]="{'show-pagination':(!totalRecords || totalRecords<20)}">
        <table class="table" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
          <tr>
            <th [hidden]="tabClicked ==='all'"></th>
            <th>Order#</th>
            <th>Order Date</th>
            <th>Contact Name</th>
            <th>Ship Address</th>
          </tr>
          </thead>
          <tbody class="table-body-custom">
          <tr *ngFor="let o of orders">
            <td [hidden]="tabClicked === 'all'">
              <div class="form-checkbox" *ngIf="tabClicked !== 'received' && tabClicked !== 'completed'">
                <input type="checkbox" id="{{o.returnOrderHeaderId}}" [(ngModel)]="o.isSelected" name="list_name"
                       (change)="selectShip(o)">
                <label for="{{o.returnOrderHeaderId}}"></label></div>
            </td>
            <td style="text-transform:capitalize;"><a routerLink="/admin/viewReturnOrder/{{o.returnOrderHeaderId}}">{{o.orderNumber}}</a>
            </td>
            <td>{{o.orderedDate}}</td>
            <td style="text-transform:capitalize;">{{o.contactName}}</td>
            <td>{{o.shippedDate}}</td>
          </tr>
          </tbody>
          <tfoot>
          <tr *ngIf="orders?.length===0|| !orders?.length">
            <td colspan="5" class="text-center">No matching records found</td>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</section>
